module.exports = __webpack_public_path__ + "img/bar-bill.fb9a20d4.svg";